export default __webpack_public_path__ + "static/AB_cares_generic-233350906a44897d15ef09dc47b02c62.jpg";